/* Quotation Service – CRUD operations for Quotations & their details */

import api from '@/api/api'
import notify from '@/utils/notify'
import router from '@/router'

export default {
  async getQuotations(storeId, params = {}) {
    const query = new URLSearchParams()
    if (params.page) query.set('page', params.page)
    if (params.per_page) query.set('per_page', params.per_page)
    if (params.search) query.set('search', params.search)

    const data = {
      method: 'get',
      url: storeId ? `quotations/${storeId}${query.toString() ? `?${query.toString()}` : ''}` : `quotations${query.toString() ? `?${query.toString()}` : ''}`
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
    return []
  },

  async createQuotation(json) {
    const data = {
      method: 'post',
      url: 'quotation',
      body: json
    }

    const response = await api.api(data)
    if (response.status === 201) {
      notify.alert.success('Quotation created successfully')
      await router.push(`/quotation/${response.data.id}`)
      return true
    }
    return false
  },

  async getQuotation(id) {
    const data = {
      method: 'get',
      url: 'quotation/' + id
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
    return null
  },

  async updateQuotation(json, id) {
    const data = {
      method: 'put',
      url: 'quotation/' + id,
      body: json
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Quotation updated successfully')
      await router.push(`/quotation/${id}`)
      return true
    }
    return false
  },

  async deleteQuotation(id) {
    const data = {
      method: 'delete',
      url: 'quotation/' + id
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Quotation deleted successfully')
      return true
    }
    return false
  },

  async getQuotationDetails(quotationId, params = {}) {
    const query = new URLSearchParams()
    if (params.page) query.set('page', params.page)
    if (params.per_page) query.set('per_page', params.per_page)
    if (params.search) query.set('search', params.search)

    const data = {
      method: 'get',
      url: `quotation/${quotationId}/details${query.toString() ? `?${query.toString()}` : ''}`
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
    return {data: [], total: 0}
  },

  async createQuotationDetails(json) {
    const data = {
      method: 'post',
      url: 'quotation-details',
      body: json
    }

    const response = await api.api(data)
    if (response.status === 201) {
      notify.alert.success('Quotation item added successfully')
      return true
    }
    return false
  },

  async updateQuotationDetails(json, id) {
    const data = {
      method: 'put',
      url: 'quotation-details/' + id,
      body: json
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Quotation item updated successfully')
      return true
    }
    return false
  },

  async deleteQuotationDetails(id) {
    const data = {
      method: 'delete',
      url: 'quotation-details/' + id
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Quotation item deleted successfully')
      return true
    }
    return false
  },

  async convertToInvoice(json, id) {
    const data = {
      method: 'post',
      url: 'quotation/' + id + '/convert',
      body: json
    }

    const response = await api.api(data)
    if (response.status === 201) {
      notify.alert.success('Quotation converted successfully')
      await router.push(`/invoice/${response.data.id}`)
      return true
    }
    return false
  }
}
